module.exports = __webpack_public_path__ + "img/circle-purple.20bf2d5b.svg";